import styled from 'styled-components';

export const StyledOrganizationField = styled.div`
	display: contents;

	input:focus:not([data-invalid]) {
		box-shadow: none;
	}
`;
